declare namespace $ {

	export class $brbr_brbr_logo extends $mol_icon_molecule {
	}
	
}

//# sourceMappingURL=logo.view.tree.d.ts.map